import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverPortal,
  PopoverTrigger as BasePopoverTrigger,
} from '@radix-ui/react-popover'
import styled from 'styled-components'

import { CloseIcon } from '@blade/ui-kit'

export interface FilterPopoverProps extends React.PropsWithChildren {
  trigger: React.ReactNode
  title: string
  isOpen?: boolean
  onOpenChange?: (isOpen: boolean) => void
}

export const FilterPopover: React.FC<FilterPopoverProps> = ({
  children,
  trigger,
  title,
  isOpen,
  onOpenChange,
}) => {
  return (
    <Popover open={isOpen} onOpenChange={onOpenChange}>
      <PopoverTrigger>{trigger}</PopoverTrigger>
      <PopoverPortal>
        <PopoverBackground>
          <PopoverPaper>
            <PopoverHeader>
              <PopoverTitle>{title}</PopoverTitle>
              <PopoverCloseButton>
                <CloseIcon />
              </PopoverCloseButton>
            </PopoverHeader>
            <PopoverLine />
            {children}
          </PopoverPaper>
        </PopoverBackground>
      </PopoverPortal>
    </Popover>
  )
}

const PopoverBackground = styled(PopoverContent)`
  border-radius: 14px;
  background: var(--background-1);
  padding: 4px;
`

const PopoverTrigger = styled(BasePopoverTrigger)`
  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
`

const PopoverPaper = styled.div`
  border-radius: 12px;
  border: 1px solid var(--backgroundA-3);

  background: var(--background-1);
  padding: 10px;

  display: flex;
  flex-direction: column;
`

const PopoverTitle = styled.div`
  color: var(--text-11);

  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding-bottom: 8px;
`

const PopoverCloseButton = styled(PopoverClose)`
  color: var(--text-11);
  width: 20px;
  height: 20px;

  cursor: pointer;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
`

const PopoverLine = () => {
  return (
    <PopoverLineRow>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="223"
        height="2"
        viewBox="0 0 223 2"
        fill="none"
      >
        <path
          opacity="0.15"
          d="M0 1H223"
          stroke="url(#paint0_radial_1461_17988)"
        />
        <defs>
          <radialGradient
            id="paint0_radial_1461_17988"
            cx="0"
            cy="0"
            r="1"
            gradientUnits="userSpaceOnUse"
            gradientTransform="translate(111.5 1.5) scale(100.421 140.5)"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
        </defs>
      </svg>
    </PopoverLineRow>
  )
}

const PopoverLineRow = styled.div`
  width: 100%;
  height: 2px;

  padding-bottom: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
`
